<template>
<Sidebar 
v-model:visible="$store.state.ui.show_search_modal" 
position="right"
class="p-sidebar-xl"
>

<div class="grid">
<div class="col-6"><h3 class="text-primary ">{{$store.state.languages.lang_phrases.arama}}</h3></div>
<div class="col-6 flex justify-content-end align-items-center">
<Button type="button"  icon="pi pi-times" :label="$store.state.languages.lang_phrases.iptal" class="p-button-danger p-button-outlined p-button-sm mr-2"  @click="close"/> 
</div>

</div>

<hr>

<template v-if="loading">
<FrameOverlay></FrameOverlay>
</template>

<template v-else>

<div class="grid mt-4">
<div class="col-12" v-for="item in notifications">
  <div class="grid">
    <div class="col-9">
      <template v-if="item.suppliernotificationhandover.status">
        <router-link  class="text-primary p-link no-underline font-bold" :to="{ name: 'UserNotification' , params: { notification_uuid:item.suppliernotificationhandover.uuid }}" >{{titleTranslation(item)}}</router-link>
      </template>
      <template v-else>
        <router-link  class="text-primary p-link no-underline font-bold" :to="{ name: 'UserNotification' , params: { notification_uuid:item.suppliernotificationhandover.uuid }}" v-badge.danger>{{titleTranslation(item)}}</router-link>
      </template>
    
    </div>

    <div class="col-3 text-right pt-2"><small class="text-purple-500">{{$filters.momentFormat( item.created_at," DD-MM-YYYY HH:mm")}}</small></div>
    <div class="col-12">
    <div class="flex align-items-center justify-content-end ">
    <Button :label="$store.state.languages.lang_phrases.goster" icon="pi pi-eye" class=" p-button-primary p-button-outlined  p-button-sm" @click="gotoNotification(item.suppliernotificationhandover.uuid)"></Button>
    </div>
    </div>
  </div>

</div>
</div>
</template>




</Sidebar>




</template>

<script>
export default {

  name: 'SearchModal',

  data () {
    return {
    	loading:false,
    	notifications:[],
    	display:"list",
      brands:[],
      loading_ticket:false,
    }
  },
  computed:{
  	show()
  	{
  		return this.$store.state.ui.show_notifications_modal
  	},
  },
  watch:{
  	show(newval)
  	{
  		if(newval)
  		{
  			this.getData()
  		}
  		else
  		{
  			this.display = "list"
  		}
  	}
  },
  methods:{
    close()
    {
      this.$store.dispatch('ui/setShowSearchModal',false)
    },
    titleTranslation(notification)
    {
      let translation = notification.translations.find((item)=>{return item.language_id==this.$store.state.auth.user.preflang_id})
      if(translation)
      {
        return translation.translation
      }
      return notification.translations[0].translation
    },
    async displayTicket(id)
    {      


    },
  	async getData()
  	{
  		this.loading = true
  		console.log("getdata")
  		let data = await this.generalApiGetWithoutLoader("get_supplier_notifications")
      this.notifications = await data
     
  		await console.log(data)
  		this.loading = false
  	},
    gotoNotification(uuid)
    {
      console.log(uuid)
      
      this.$router.push({ name: 'UserNotification', params: { notification_uuid:uuid } })
      
    }

  }
}
</script>

<style lang="css" scoped>
</style>vuec